import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Subsea from './childApps/subsea/Subsea';
import MissingAssets from './childApps/missingassets/MissingAssets';
import ReservationsReportFull from './childApps/reservationsReport/ReservationsReportFull';
import ReservationsReport from './childApps/reservationsReport/ReservationsReport';
import ReservationsReportV2 from './childApps/reservationsReport/ReservationsReportV2';
import { AssetsSensorsList } from './childApps/assetsSensorsList/AssetsSensorsList';
import { Login } from './Login';
import { ProtectedRoutes } from './ProtectedRoute';
import { AuthProvider } from './hooks/useAuth';

import { Provider } from 'react-redux';
import { store } from './state/store';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RoomCleaned from './childApps/roomCleaned/RoomCleaned';
import RoomUnderCleaning from './childApps/roomUnderCleaning/RoomUnderCleaning';

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <Routes>
          <Route element={<ProtectedRoutes />}>
            <Route path="/*" element={<App />} />
            <Route
              path="/assets_sensors_list"
              element={<AssetsSensorsList />}
            />
            <Route path="/subsea" element={<Subsea />} />
            <Route path="/roomcleaned" element={<RoomCleaned />} />
            <Route path="/roomundercleaning" element={<RoomUnderCleaning />} />

            <Route path="/missingassets" element={<MissingAssets />} />
            <Route
              path="/reservations_report_full"
              element={<ReservationsReportFull />}
            />
            <Route
              path="/reservations_report"
              element={<ReservationsReport />}
            />
            <Route
              path="/reservations_report_v2"
              element={<ReservationsReportV2 />}
            />
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </AuthProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);
